/*
 * Pestanas de producto: cambia de panel y mueve `aria-selected`. Nada mas.
 *
 * Todo lo que se ve sale del servidor -la lista de pestanas, el primer panel
 * visible, los demas con `hidden`-, asi que sin este fichero se ve la primera
 * pestana y no falta nada. Aqui solo vive lo que un `tablist` accesible pide y
 * el HTML no puede hacer solo: el clic, las flechas del teclado y el foco.
 *
 * Va en un asset y no en un `<script>` dentro del bloque porque el bloque
 * puede estar dos veces en la pagina y el codigo se descarga una.
 */
(() => {
  const montar = (raiz) => {
    if (raiz.dataset.nnMontado) return;
    raiz.dataset.nnMontado = 'si';

    const pestanas = [...raiz.querySelectorAll(':scope > [role="tablist"] > [role="tab"]')];
    const paneles = [...raiz.querySelectorAll(':scope > [role="tabpanel"]')];
    if (pestanas.length < 2 || pestanas.length !== paneles.length) return;

    const activar = (indice, enfocar) => {
      pestanas.forEach((pestana, k) => {
        const activa = k === indice;
        pestana.setAttribute('aria-selected', activa ? 'true' : 'false');
        pestana.tabIndex = activa ? 0 : -1;
        paneles[k].hidden = !activa;
      });
      if (enfocar) pestanas[indice].focus();
      /* El carrusel de movil de Horizon mide sus diapositivas al montarse, y
         montado dentro de un panel oculto mide cero. Un `resize` le hace
         volver a medir ahora que se ve. */
      window.dispatchEvent(new Event('resize'));
    };

    pestanas.forEach((pestana, i) => {
      pestana.addEventListener('click', () => activar(i, false));
      pestana.addEventListener('keydown', (evento) => {
        const n = pestanas.length;
        let destino = null;
        if (evento.key === 'ArrowRight') destino = (i + 1) % n;
        else if (evento.key === 'ArrowLeft') destino = (i - 1 + n) % n;
        else if (evento.key === 'Home') destino = 0;
        else if (evento.key === 'End') destino = n - 1;
        if (destino === null) return;
        evento.preventDefault();
        activar(destino, true);
      });
    });
  };

  const montarTodas = (ambito) => {
    ambito.querySelectorAll('[data-nn-pestanas]').forEach(montar);
  };

  montarTodas(document);
  /* El editor de temas vuelve a pintar la seccion al cambiar un ajuste. */
  document.addEventListener('shopify:section:load', (evento) => montarTodas(evento.target));
})();
